var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLatin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.25C13.4142 10.25 13.75 10.5858 13.75 11V22.25C13.75 22.8023 14.1977 23.25 14.75 23.25H20.7639C21.8501 23.25 22.8431 22.6364 23.3291 21.665C23.5143 21.2947 23.9646 21.1442 24.335 21.3291C24.7053 21.5143 24.8558 21.9646 24.6709 22.335L23.7402 24.1971C23.5709 24.5359 23.2246 24.75 22.8457 24.75H10C9.58581 24.75 9.25 24.4142 9.25 24C9.25 23.5858 9.58581 23.25 10 23.25C11.2426 23.25 12.25 22.2426 12.25 21V11C12.25 10.5858 12.5858 10.25 13 10.25ZM19 7.25C19.4142 7.25 19.75 7.58579 19.75 8C19.75 8.41421 19.4142 8.75 19 8.75C17.7574 8.75 16.75 9.75736 16.75 11V21C16.75 21.4142 16.4142 21.75 16 21.75C15.5858 21.75 15.25 21.4142 15.25 21V9.75C15.25 9.19772 14.8023 8.75 14.25 8.75H10C9.80109 8.75 9.61038 8.82907 9.46973 8.96973C9.32907 9.11038 9.25 9.30109 9.25 9.5C9.25 9.69891 9.32907 9.88962 9.46973 10.0303C9.61038 10.1709 9.80109 10.25 10 10.25C10.4142 10.25 10.75 10.5858 10.75 11C10.75 11.4142 10.4142 11.75 10 11.75C9.40326 11.75 8.83114 11.5128 8.40918 11.0908C7.98722 10.6689 7.75 10.0967 7.75 9.5C7.75 8.90326 7.98722 8.33114 8.40918 7.90918C8.83114 7.48722 9.40326 7.25 10 7.25H19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatin2);
export default __webpack_public_path__ + "static/media/Latin2.3c66d9c5180ba0b07e39ab6584228f78.svg";
export { ForwardRef as ReactComponent };